














































































import { Component, Vue } from "vue-property-decorator";
import BotConfiguration from "@/store/entities/botConfiguration";

@Component({})
export default class BotManagement extends Vue {
  headers: Array<{text: string; value: string}> = [];
  breadcrumbsItems: Array<{text: string; disabled: boolean; href?: string}> = [];
  botConfigurations: BotConfiguration[] = [];
  openedGroups: string[] = [];
  pegasMinPriceInput: number | null = null;
  pegasSaving: boolean = false;

  async getBotConfigurations(): Promise<void> {
    try {
      await this.$store.dispatch({
        type: "botConfiguration/getBotConfigurations"
      });
      
      this.botConfigurations = this.$store.state.botConfiguration.list;
    } catch (error) {
      console.error("Bot yapılandırmaları yüklenirken hata:", error);
      this.$toast.error("Bot yapılandırmaları yüklenemedi");
    }
  }

  async created(): Promise<void> {
    await this.getBotConfigurations();
    await this.$store.dispatch({ type: 'botConfiguration/getPegasMinPrice' });
    this.pegasMinPriceInput = this.$store.state.botConfiguration.pegasMinPrice;
    
    this.headers = [
      { text: "Referrer ID", value: "referrerId" },
      { text: "Servis Adı", value: "serviceName" },
      { text: "Durum", value: "isEnabled" },
    ];

    this.breadcrumbsItems = [
      { text: "Ana Sayfa", disabled: false, href: "/#/main/home" },
      { text: "Bot Yönetimi", disabled: true },
    ];
  }

  toggleGroup(referrerId: string): void {
    const index = this.openedGroups.indexOf(referrerId);
    if (index > -1) {
      this.openedGroups.splice(index, 1);
    } else {
      this.openedGroups.push(referrerId);
    }
  }

  isGroupOpen(referrerId: string): boolean {
    return this.openedGroups.includes(referrerId);
  }

  async toggleBotStatus(item: BotConfiguration): Promise<void> {
    try {
      await this.$store.dispatch({
        type: "botConfiguration/saveBotConfiguration",
        data: {
          id: item.id,
          refId: item.refId,
          serviceId: item.serviceId,
          isEnabled: item.isEnabled
        }
      });
      
      this.$toast.success(`${item.serviceName} botu ${item.isEnabled ? 'aktif' : 'pasif'} edildi`);
    } catch (error) {
      console.error("Bot durumu güncellenirken hata:", error);
      this.$toast.error("Bot durumu güncellenemedi");
      // Hata durumunda eski değere geri çevir
      item.isEnabled = !item.isEnabled;
    }
  }

  async savePegasMinPrice(): Promise<void> {
    if (this.pegasMinPriceInput === null || this.pegasMinPriceInput === undefined) {
      this.$toast.error('Lütfen bir değer girin');
      return;
    }
    this.pegasSaving = true;
    try {
      await this.$store.dispatch({ type: 'botConfiguration/setPegasMinPrice', price: this.pegasMinPriceInput });
      await this.$store.dispatch({ type: 'botConfiguration/getPegasMinPrice' });
      this.$toast.success('Pegas minimum fiyat güncellendi');
    } catch (error) {
      this.$toast.error('Kayıt sırasında hata oluştu');
    } finally {
      this.pegasSaving = false;
    }
  }

  get groupedBotConfigurations() {
    return this.botConfigurations
      .sort((a, b) => {
        // Önce referrerId'ye göre sırala
        const referrerIdCompare = a.referrerId.localeCompare(b.referrerId);
        if (referrerIdCompare !== 0) return referrerIdCompare;
        
        // Aynı referrerId içindeki servisleri serviceName'e göre sırala
        return a.serviceName.localeCompare(b.serviceName);
      });
  }

  get groupByReferrerId(): string {
    return "referrerId";
  }

  get loading(): boolean {
    return this.$store.state.botConfiguration.loading;
  }
}
